import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext, useEffect, useState } from 'react';
import { useT } from '@progress-fe/core';
import { DialogableContainer } from '../../containers';
import { JsFormConfigContext } from '../../../contexts';
import { JsFieldInspector } from '../../jsFormBase';
import { OilBlendRangesTable } from './components';
/**
 * Component renders "/schemas/jsf-oil-blend-model" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is an instance of TOilBlendModelFormData.
 */
const OilBlendModelJsFieldFC = (props) => {
    const { isInspector } = useContext(JsFormConfigContext) ?? {};
    const [ranges, setRanges] = useState([]);
    const { t } = useT();
    const formData = props.formData;
    const fieldConfig = formData.fieldConfig;
    useEffect(() => {
        if (!formData.fieldValues.value.length) {
            setRanges([
                {
                    [fieldConfig.min.name]: fieldConfig.min.value.toString(),
                    [fieldConfig.max.name]: fieldConfig.max.value.toString()
                }
            ]);
            return;
        }
        setRanges(formData.fieldValues.value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleChangeFormValue = (value) => {
        props.onChange({
            ...formData,
            fieldValues: {
                ...formData.fieldValues,
                value
            }
        });
    };
    const handleCreateRange = (splitValue, rangeIdxToSplit) => {
        const newRanges = [...ranges];
        const addedRanges = [
            { ...ranges[rangeIdxToSplit], [fieldConfig.max.name]: splitValue },
            { ...ranges[rangeIdxToSplit], [fieldConfig.min.name]: splitValue }
        ];
        newRanges.splice(rangeIdxToSplit, 1, ...addedRanges);
        setRanges(newRanges);
        handleChangeFormValue(newRanges);
    };
    const handleDeleteRange = (idx) => {
        // we can't delete the first one
        if (!idx) {
            return;
        }
        const deletedRange = ranges[idx];
        const prevRange = {
            ...ranges[idx - 1],
            [fieldConfig.max.name]: deletedRange[fieldConfig.max.name]
        };
        const newRanges = [...ranges];
        newRanges.splice(idx - 1, 2, prevRange);
        setRanges(newRanges);
        handleChangeFormValue(newRanges);
    };
    const handleRangeChange = (rangeVal, idx) => {
        const newRanges = structuredClone(ranges);
        const prev = newRanges[idx - 1];
        const next = newRanges[idx + 1];
        if (prev && prev[fieldConfig.max.name] !== rangeVal[fieldConfig.min.name]) {
            prev[fieldConfig.max.name] = rangeVal[fieldConfig.min.name];
        }
        if (next && next[fieldConfig.min.name] !== rangeVal[fieldConfig.max.name]) {
            next[fieldConfig.min.name] = rangeVal[fieldConfig.max.name];
        }
        newRanges[idx] = { ...rangeVal };
        setRanges(newRanges);
        handleChangeFormValue(newRanges);
    };
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['object'], children: _jsx(DialogableContainer, { "data-testid": "OilBlendModelJsField-test", "data-name": props.name, title: t('jsfields.OilBlendModel.dialogTitle'), children: (isDialog, handleToggleDialog) => {
                return (_jsx(OilBlendRangesTable, { ranges: ranges, isDialog: isDialog, formData: formData, isReadOnly: !!props.schema.readOnly, suffix: props.schema.$comment, onCreateRange: handleCreateRange, onDeleteRange: handleDeleteRange, onRangeChanged: handleRangeChange, onToggleDialog: handleToggleDialog }));
            } }) }));
};
export const OilBlendModelJsField = memo(OilBlendModelJsFieldFC);
//# sourceMappingURL=OilBlendModelJsField.js.map